"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addControls = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _ToolbarButton = _interopRequireDefault(require("rich-text-lib/components/toolbar/ToolbarButton"));

var _toolbar = require("../constants/toolbar");

var _hslink = require("../constants/hslink");

var _ToolbarButton2 = _interopRequireDefault(require("../components/ToolbarButton"));

var _LinkToolbarButton = _interopRequireDefault(require("../components/toolbar/LinkToolbarButton"));

var _utils = require("../utils");

var _link = require("../utils/link");

var _ReactButton = require("../controls/ReactButton");

var _i18n = require("../utils/i18n");

var i18nKey = (0, _i18n.i18nWithNameSpace)('TinymcePlugins.hslink');

var addCommands = function addCommands(editor) {
  // Override the builtin insert link command so that spaces are not automatically replaced
  // with %20 since they often are often used in HubL
  editor.addCommand('mceInsertLink', function (ui, value) {
    var dom = editor.dom,
        formatter = editor.formatter,
        selection = editor.selection;

    if (typeof value === 'string') {
      value = {
        href: value
      };
    }

    var anchor = dom.getParent(selection.getNode(), 'a'); // Remove existing links if there could be child links or that the href isn't specified

    if (!anchor || !value.href) {
      formatter.remove('link');
    } // Apply new link to selection


    if (value.href) {
      formatter.apply('link', value, anchor);
    }
  });
};

var addControls = function addControls(_ref) {
  var editor = _ref.editor,
      onSelectFile = _ref.onSelectFile,
      onChangeLink = _ref.onChangeLink,
      fetchPages = _ref.fetchPages,
      fetchPageBySlug = _ref.fetchPageBySlug,
      fetchFileFromUrl = _ref.fetchFileFromUrl,
      fetchMeetings = _ref.fetchMeetings,
      fetchMeetingBySlug = _ref.fetchMeetingBySlug,
      fetchAnchors = _ref.fetchAnchors,
      allowFileDownload = _ref[_hslink.hslinkConfig.ALLOW_FILE_DOWNLOAD],
      allowMeetingLink = _ref[_hslink.hslinkConfig.ALLOW_MEETING_LINKS],
      allowAnchorLinks = _ref[_hslink.hslinkConfig.ALLOW_ANCHOR_LINKS];

  var getReactElement = function getReactElement(renderButton) {
    return _react.default.createElement(_LinkToolbarButton.default, {
      editor: editor,
      removeUnInsertedLinks: (0, _link.removeUnInsertedLinks)(editor),
      onSelectFile: onSelectFile,
      onChangeLink: onChangeLink,
      fetchPages: fetchPages,
      showRefAndTargetControls: !(0, _utils.getPluginSetting)(editor, 'isEmail'),
      useEmailSubscription: !!(0, _utils.getPluginSetting)(editor, 'isEmail'),
      allowFileDownload: allowFileDownload,
      allowMeetingLink: allowMeetingLink,
      allowAnchorLinks: allowAnchorLinks,
      keyboardShortcutEvent: _hslink.LINK_SHORTCUT,
      fetchPageBySlug: fetchPageBySlug,
      fetchFileFromUrl: fetchFileFromUrl,
      fetchMeetings: fetchMeetings,
      fetchAnchors: fetchAnchors,
      fetchMeetingBySlug: fetchMeetingBySlug,
      renderButton: renderButton
    });
  };

  editor.addButton('link', function () {
    return {
      type: _ReactButton.REACT_BUTTON_TYPE,
      stateSelector: 'a[href]',
      tooltip: i18nKey('tooltip.insertOrEdit'),
      reactElement: getReactElement(function (handleClick) {
        return _react.default.createElement(_ToolbarButton2.default, {
          iconName: "link",
          onClick: handleClick
        });
      })
    };
  });
  editor.addButton('canvaslink', {
    type: _toolbar.CANVAS_BUTTON_TYPE,
    renderControl: function renderControl(props) {
      return getReactElement(function (handleClick, isActive, type) {
        return _react.default.createElement(_ToolbarButton.default, (0, _extends2.default)({
          iconName: "link",
          "data-test-id": "insert-link-button",
          tooltip: i18nKey("tooltip." + type),
          onClick: handleClick,
          selected: isActive
        }, props));
      });
    }
  });
  editor.addShortcut('Meta+K', '', function () {
    return editor.fire(_hslink.LINK_SHORTCUT);
  });
  addCommands(editor);
};

exports.addControls = addControls;